export * from './src/datepicker.module';



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./~/angular2-material-datepicker/index.ts